import script from "./LazyScript.vue?vue&type=script&lang=ts"
export * from "./LazyScript.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__